<template>
  <el-dialog
    title="导航和定位更新"
    :visible.sync="visible"
    width="600px"
    :before-close="handleClose">
    <el-form ref="form"
             size="small"
             :model="form"
             label-width="140px">
      <el-form-item label="场地楼层">
        <el-input placeholder="根据场地楼层获取定位服务镜像版本"
                  @blur="getVersion"
                  style="width: 390px"
                  v-model="form.group_floor"></el-input>
      </el-form-item>
      <el-form-item label="底库唯一标识">
        <el-input style="width: 390px" v-model="form.ar_id"></el-input>
      </el-form-item>
      <el-form-item label="定位服务镜像版本">
        <el-input :disabled="true" style="width: 390px" v-model="form.version"></el-input>
      </el-form-item>
      <el-form-item label="环境">
        <el-input style="width: 390px" v-model="form.env"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="cancel()">取 消</el-button>
      <el-button size="mini"
                 type="primary"
                 :disabled="btnDisabled"
                 @click="confirm()">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getDeployVersion, locationDeployment } from '@/api/deploy';

export default {
  name: 'DeployDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      host: 'https://ar-manager.aibee.cn',
      form: {
        group_floor: '',
        ar_id: '',
        version: '',
        env: '',
      },
    };
  },
  computed: {
    btnDisabled() {
      return this.form.version === '' || !this.form.group_floor || !this.form.version || !this.form.env;
    },
  },
  methods: {
    getVersion() {
      console.log(this.form.group_floor);
      // http://127.0.0.1:8080/algo-ar/admin/ar/location_deployment/version?group_floor=AIBEE_BJ_TEST,L1&token=
      const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjotMSwibW9kZSI6InJvYm90IiwidXNlcm5hbWUiOiJyb2JvdCIsImV4cGlyZV9hdCI6MzMxNTEyNzUwNjF9.3b2tJXicsc67cqfDv6zlqcfDH60tZ92Gm31CcK1izyE';
      getDeployVersion({
        group_floor: this.form.group_floor.trim(),
        token,
      }).then((res) => {
        console.log('res', res);
        this.form.version = res;
      }).catch(() => {
        this.$message({
          message: '获取定位服务镜像版本失败',
          type: 'error',
        });
      });
    },
    handleClose() {
      this.form = {
        group_floor: '',
        ar_id: '',
        version: '',
        env: '',
      };
      this.$emit('closeNavAndPos');
    },
    cancel() {
      this.form = {
        group_floor: '',
        ar_id: '',
        version: '',
        env: '',
      };
      this.$emit('closeNavAndPos');
    },
    confirm() {
      console.log(this.form);
      // this.$emit('closeNavAndPos')
      const groupFloor = this.form.group_floor.trim();
      const arId = this.form.ar_id.trim();
      const version = this.form.version.trim();
      const env = this.form.env.trim();
      /**
       * token 是永久 token  永远不变
       * @type {string}
       */
      const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjotMSwibW9kZSI6InJvYm90IiwidXNlcm5hbWUiOiJyb2JvdCIsImV4cGlyZV9hdCI6MzMxNTEyNzUwNjF9.3b2tJXicsc67cqfDv6zlqcfDH60tZ92Gm31CcK1izyE';
      locationDeployment({
        group_floor: groupFloor,
        env,
        ar_id: arId,
        version,
        token,
      }).then((res) => {
        console.log('res', res);
        this.$message({
          message: '操作成功',
          type: 'success',
        });
        this.cancel();
      }).catch(() => {
        this.$message({
          message: '操作失败',
          type: 'error',
        });
      });
    },
  },
};
</script>
<style scoped>

</style>
